import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.19_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
